// extracted by mini-css-extract-plugin
export default {"root":"StoryAnalytic_root__kB4GA","item":"StoryAnalytic_item__OSj2W","button":"StoryAnalytic_button__rFyr8","text":"StoryAnalytic_text__U9H5c","icon":"StoryAnalytic_icon__jjXu0"};